import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TenantService {

  private tenantIdSource = new BehaviorSubject<string | null>(null);
  currenttenantId = this.tenantIdSource.asObservable();

  constructor() {
    const storedTenant = sessionStorage.getItem('selectedTenant');
    if (storedTenant) {
      this.tenantIdSource.next(storedTenant);
    }
}

  changetenantId(tenantId: string | null): void {
    sessionStorage.setItem('selectedTenant', tenantId);
    this.tenantIdSource.next(tenantId);
  }
}